import { Navigate, Outlet } from "react-router-dom";
import Navbar from "../_components/common/Navbar";
import Header from "../_components/common/Header";
import { useContextFromUrl } from "../hooks/useContextFromUrl";


const ProtectedRoutesOutlet = () => {
  useContextFromUrl();
  const auth = { token: localStorage.getItem('access_token_AS') };
  // const auth = { token: null };

  return auth.token ? (
    <div className="protected-layout">
     
      <Navbar />
      <main className="protected-main app-background">
        <div className="protected-main-surface">
          <Header />
          <Outlet />
        </div>
      </main>
    </div>
  ) : (
    <Navigate to="/login" />
  );
};

export default ProtectedRoutesOutlet;
